import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_ds_inventory_transfer_statusService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventoryTransferId: number }): 
  Promise<{ result: { Id?: number, Status?: { Id?: number, EnumName?: string, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_status/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventoryTransferId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Status?: { Id?: number, EnumName?: string, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_status/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventoryTransferId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, Status?: { Id?: number, EnumName?: string, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferId)) {
      missingRequiredInParams.push('\'inventoryTransferId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/datasources/ds_inventory_transfer_status/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventoryTransferId: number    }) {
        if(isNil(inParams.inventoryTransferId)) {
          return true; 
        }
      return false;
    }
}
